const pgcetmbaQuantitativeAnalysis = [
  {
    id: 41,
    question: "A packet contains 3 yellow balloons, 4 blue balloons, and 5 green balloons. In how many ways can 4 balloons be drawn from the box if at least one blue balloon is to be included in the draw?",
    options: ["A. 328", "B. 481", "C. 364", "D. 425"],
    answer: "D"
  },
  {
    id: 42,
    question: "The mean of five numbers is 18. If one of the numbers is excluded, the mean of the remaining four numbers becomes 16. What is the excluded number?",
    options: ["A. 22", "B. 26", "C. 24", "D. 28"],
    answer: "B"
  },
  {
    id: 43,
    question: "Find the interquartile range for the given data series: 21, 24, 25, 22, 26, 26, 29, 27, 28, 27, 32, 33, 32, 35, 36, 36, 37, 35",
    options: ["A. 7", "B. 9", "C. 5", "D. 10"],
    answer: "B"
  },
  {
    id: 44,
    question: "If the median of the distribution given below is 28.5, find the values of x and y. (Class interval: Frequency) 0-10: 5; 10-20: x; 20-30: 20; 30-40: 15; 40-50: y; 50-60: 5; Total: 60.",
    options: ["A. x = 8, y = 7", "B. x = 7, y = 8", "C. x = 9, y = 8", "D. x = 8, y = 9"],
    answer: "A"
  },
  {
    id: 45,
    question: "The eighth term of an AP is half of its second term and 11th term exceeds one third of fourth term by 1. Find the 15th term.",
    options: ["A. 3", "B. 4", "C. 5", "D. 6"],
    answer: "A"
  },
  {
    id: 46,
    question: "Given that ΔABC ~ ΔDEF, if BC = 12.5 cm and EF = 10 cm, then the areas of ΔABC and ΔDEF are in the ratio of:",
    options: ["A. 3 : 4", "B. 25 : 16", "C. 16 : 25", "D. 1 : 2"],
    answer: "B"
  },
  {
    id: 47,
    question: "ABCD is a quadrilateral in which AB is parallel to CD. Diagonals AC and BD intersect at P. If AP = k + 1, BP = k + 3, CP = k − 2 and DP = k − 1, find the value of k.",
    options: ["A. 6", "B. 5", "C. 4", "D. 7"],
    answer: "B"
  },
  {
    id: 48,
    question: "Three partners A, B and C invest Rs. 5750 towards the capital of their firm. A invested Rs. 500 more than B and B invested Rs. 750 more than C. The firm makes a profit of Rs. 23000 during the year. The share of the profit that A gets is:",
    options: [
      "A. Rs. 5000 more than the sum of the shares of B and C",
      "B. Rs. 3000 less than the sum of the shares of B and C",
      "C. Rs. 2000 more than the sum of the shares of B and C",
      "D. Rs. 750 less than the sum of the shares of B and C"
    ],
    answer: "B"
  },
  {
    id: 49,
    question: "Raghavan purchased a scooter at 13/15 of its selling price and sold it at 12% more than its selling price. His gain % is:",
    options: ["A. 20%", "B. 29 3/13 %", "C. 30%", "D. 38 1/13 %"],
    answer: "B"
  },
  {
    id: 50,
    question: "The number of candidates (in hundreds) who appeared from zone T over the years 2005 to 2010 was 6.2, 6.2, 6.4, 7.8, 9.9 and 11.8 respectively. What was the average number of candidates who appeared from zone T over all the years together?",
    options: ["A. 810", "B. 815", "C. 835", "D. 805"],
    answer: "D"
  },
  {
    id: 51,
    question: "In zone S, the candidates who appeared and qualified (in hundreds) over 2005 to 2010 were: 2005 (4.2, 2.4), 2006 (7.4, 3.3), 2007 (8.3, 5.6), 2008 (9.3, 6.4), 2009 (11.4, 5.2), 2010 (14.2, 11.4). In which year was the difference between the appeared candidates and qualified candidates the second lowest?",
    options: ["A. 2005", "B. 2007", "C. 2008", "D. 2009"],
    answer: "B"
  },
  {
    id: 52,
    question: "The number of candidates (in hundreds) who qualified for the test in 2009 and 2010 together from various zones was: P = 10.4, Q = 11.6, R = 14.2, S = 16.6, T = 16.3. From which zone was the total number of qualified candidates the second-highest?",
    options: ["A. P", "B. Q", "C. R", "D. T"],
    answer: "D"
  },
  {
    id: 53,
    question: "The number of candidates who qualified for the test from zone R in the year 2010 was 7.4 (hundreds), and the number who appeared from zone Q in the year 2008 was 5.4 (hundreds). The number who qualified from zone R in 2010 is approximately what percentage of the number who appeared from zone Q in 2008?",
    options: ["A. 132%", "B. 147%", "C. 142%", "D. 137%"],
    answer: "D"
  },
  {
    id: 54,
    question: "A and B can complete a piece of work in 12 days while B can complete the same piece of work in 18 days. In how many days can A alone complete 25% of the same piece of work?",
    options: ["A. 9", "B. 12", "C. 15", "D. 18"],
    answer: "A"
  },
  {
    id: 55,
    question: "A boy standing in the middle of a field observes a flying bird in the North at an angle of elevation of 30° and after two minutes he observes the same bird in the south at an angle of elevation of 60°. If the bird flies all along in a straight line at a height of 50√3 m, then find its speed in km/hr.",
    options: ["A. 4.5", "B. 3", "C. 9", "D. 6"],
    answer: "D"
  },
  {
    id: 56,
    question: "A person crosses a 455-meter long distance in 35 minutes. What is his speed in km/hr?",
    options: ["A. 0.52", "B. 0.95", "C. 0.62", "D. 0.78"],
    answer: "D"
  },
  {
    id: 57,
    question: "The average weight of 150 people sitting in an airplane is 80 kg and the sum of the weight of the aeroplane and 150 people sitting in an aeroplane is 35000 kg. Find the weight of the aeroplane.",
    options: ["A. 10000 kg", "B. 15000 kg", "C. 25000 kg", "D. 23000 kg"],
    answer: "D"
  },
  {
    id: 58,
    question: "AB and CD are the diameters of a circle which intersect at P. Join AC, CB, BD and DA. If ∠PAD = 60°, then what is ∠BPD?",
    options: ["A. 30°", "B. 60°", "C. 90°", "D. 120°"],
    answer: "D"
  },
  {
    id: 59,
    question: "A line graph gives the annual percent profit earned by a company. The profit % was 55% in 1996 and 70% in 1999. If the expenditures in 1996 and 1999 are equal, then the approximate ratio of the income in 1996 and 1999 respectively is:",
    options: ["A. 1 : 1", "B. 2 : 3", "C. 13 : 14", "D. 9 : 10"],
    answer: "D"
  },
  {
    id: 60,
    question: "The percent profit earned by a company in 1998 was 65%. If the income in 1998 was Rs. 264 crores, what was the expenditure in 1998?",
    options: ["A. Rs. 104 crores", "B. Rs. 145 crores", "C. Rs. 160 crores", "D. Rs. 185 crores"],
    answer: "C"
  }
];

export default pgcetmbaQuantitativeAnalysis;